import { Country } from "@linkfluence/models/country";

const Populations: Record<Country, number> = {
  AD: 76246,
  AE: 8264070,
  AF: 32564342,
  AG: 91295,
  AI: 15000,
  AL: 3063320,
  AM: 3060631,
  //AN: 1,
  AO: 19088106,
  //AQ: 1500,
  AR: 43590400,
  AS: 196628,
  AT: 8458023,
  AU: 24000300,
  AW: 102911,
  AX: 28355,
  AZ: 9235100,
  BA: 3836377,
  BB: 289680,
  BD: 160339154,
  BE: 11258434,
  BF: 17322796,
  BG: 7284552,
  BH: 1314089,
  BI: 9420248,
  BJ: 10160556,
  BL: 9793,
  BM: 65024,
  BN: 422675,
  BO: 10800882,
  BQ: 150000,
  BR: 207096196,
  BS: 321834,
  BT: 733643,
  // BV: 1,
  BW: 2155784,
  BY: 9498700,
  BZ: 340844,
  CA: 35702707,
  CC: 596,
  CD: 79375136,
  CF: 5277959,
  CG: 4662446,
  CH: 8211681,
  CI: 22671331,
  CK: 14974,
  CL: 16572475,
  CM: 20386799,
  CN: 1381943057,
  CO: 48529500,
  CR: 4713168,
  CU: 11163934,
  CV: 538535,
  CW: 150000,
  // CX: 2072,
  CY: 1102677,
  CZ: 10538275,
  DE: 82800000,
  DJ: 810179,
  DK: 5707251,
  DM: 73449,
  DO: 9980243,
  DZ: 40400000,
  EC: 15445691,
  EE: 1313271,
  EG: 90416900,
  EH: 554795,
  ER: 6380803,
  ES: 48146134,
  ET: 92206005,
  FI: 5499514,
  FJ: 903207,
  // FK: 2932,
  FM: 105681,
  FO: 49469,
  FR: 67595000,
  GA: 1672597,
  GB: 65097000,
  GD: 110152,
  GE: 4490500,
  GF: 250377,
  GG: 65228,
  GH: 27043093,
  GI: 30001,
  GL: 56483,
  GM: 1925527,
  GN: 11474383,
  GP: 403750,
  GQ: 1222242,
  GR: 9903268,
  GS: 30,
  GT: 14647083,
  GU: 165124,
  GW: 1693398,
  GY: 735554,
  HK: 7188000,
  HM: 1,
  HN: 8576532,
  HR: 4470534,
  HT: 10911819,
  HU: 9957731,
  ID: 262323733,
  IE: 4609600,
  IL: 8334000,
  IM: 85888,
  IN: 1331787890,
  IO: 4000,
  IQ: 36575000,
  IR: 81824270,
  IS: 321857,
  IT: 61855120,
  JE: 99500,
  JM: 2717991,
  JO: 6706051,
  JP: 126820000,
  KE: 47251000,
  KG: 5895062,
  KH: 15458332,
  KI: 104488,
  KM: 766865,
  KN: 51538,
  KP: 24851627,
  KR: 51541582,
  KW: 2742711,
  KY: 58435,
  KZ: 17541200,
  LA: 6803699,
  LB: 5882562,
  LC: 163362,
  LI: 36842,
  LK: 20675000,
  LR: 4092310,
  LS: 1942008,
  LT: 2939431,
  LU: 563000,
  LV: 2001468,
  LY: 6244174,
  MA: 33322699,
  MC: 37800,
  MD: 3555200,
  ME: 650036,
  MF: 35107,
  MG: 21842167,
  MH: 70983,
  MK: 2064032,
  ML: 16455903,
  MM: 54363000,
  MN: 2953190,
  MO: 566375,
  MP: 53855,
  MQ: 386486,
  MR: 3516806,
  MS: 5164,
  MT: 446547,
  MU: 1331155,
  MV: 393595,
  MW: 15805239,
  MX: 122273500,
  MY: 30417000,
  MZ: 27220000,
  NA: 2198406,
  NC: 262000,
  NE: 16274738,
  // NF: 2210,
  NG: 186988000,
  NI: 6167237,
  NL: 16989600,
  NO: 5214890,
  NP: 28000000,
  // NR: 9488,
  NU: 1611,
  NZ: 4661320,
  OM: 3623000,
  PA: 3608431,
  PE: 30147935,
  PF: 274217,
  PG: 6552730,
  PH: 102815800,
  PK: 192798246,
  PL: 38484000,
  PM: 6080,
  // PN: 56,
  PR: 3548000,
  PS: 4550368,
  PT: 10374822,
  PW: 21186,
  PY: 6703860,
  QA: 2334029,
  RE: 843610,
  RO: 19942642,
  RS: 7209764,
  RU: 146519759,
  RW: 12337138,
  SA: 30770375,
  SB: 609883,
  SC: 91650,
  SD: 39598700,
  SE: 9551781,
  SG: 5312400,
  SH: 7729,
  SI: 2062874,
  SJ: 18,
  SK: 5421349,
  SL: 5743725,
  SM: 32480,
  SN: 13567338,
  SO: 12316895,
  SR: 1820631,
  SS: 12530717,
  ST: 190428,
  SV: 6125512,
  SX: 37224,
  SY: 21895150,
  SZ: 1419623,
  TC: 33098,
  TD: 11412107,
  // TF: 196,
  TG: 7351374,
  TH: 65242920,
  TJ: 8354000,
  TK: 1411,
  TL: 1201542,
  TM: 5171943,
  TN: 10982754,
  TO: 106440,
  TR: 78741053,
  TT: 1223916,
  TV: 10782,
  TW: 23449287,
  TZ: 55155000,
  UA: 42774605,
  UG: 37101745,
  // UM: 300,
  US: 325270439,
  UY: 3332972,
  UZ: 30492800,
  VA: 921,
  VC: 102918,
  VE: 30206307,
  VG: 28054,
  VI: 104983,
  VN: 91700000,
  VU: 266937,
  WF: 15500,
  WS: 196628,
  XX: 0,
  YE: 26180000,
  YT: 212645,
  ZA: 54956900,
  ZM: 14638505,
  ZW: 13771721,
};

export function getCountryPopulation(country: Country) {
  return Populations[country];
}

export function getAllCountriesPopulation() {
  return Populations;
}
